import { render, staticRenderFns } from "./EmailSenderPage.vue?vue&type=template&id=4f16bc39&"
import script from "./EmailSenderPage.vue?vue&type=script&lang=js&"
export * from "./EmailSenderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f16bc39')) {
      api.createRecord('4f16bc39', component.options)
    } else {
      api.reload('4f16bc39', component.options)
    }
    module.hot.accept("./EmailSenderPage.vue?vue&type=template&id=4f16bc39&", function () {
      api.rerender('4f16bc39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/email/EmailSenderPage.vue"
export default component.exports